import {combineReducers} from "redux";
import ErrorAuthReducer from "./AuthReducer/AuthErrorsReducer";
import ForgetPasswordReducer from "./AuthReducer/ForgetPasswordReducer";
import SignInReducer from "./AuthReducer/SignInReducer";
import SignUpReducer from "./AuthReducer/SignUpReducer";
import ResetPasswordReducer from "./AuthReducer/ResetPasswordReducer";

export default combineReducers({
    signIn: SignInReducer,
    signUp: SignUpReducer,
    forgetPassword: ForgetPasswordReducer,
    resetPassword: ResetPasswordReducer,

    errors: ErrorAuthReducer,
});

